<template>
    <cadastro-simples-form
        endpoint="situacao-requerimento"
        rota-base="/admin/situacao-requerimento"
        titulo-singular="Situação de Requerimento"
        :campos-extras='[{"campo":"cor","label":"Cor (hex)","tipo":"string","maxLength":9,"descricao":"Ex.: #67c23a"},{"campo":"ordem","label":"Ordem","tipo":"int"}]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
